import globalSlice from "./slices/globalSlice";
import issueSlice from "./slices/issueSlice";
import projectSlice from "./slices/projectSlice";
import activeSprintSlice from "./slices/activeSprintSlice";
import profileSlice from "./slices/profileSlice";
import backlogSlice from "./slices/backlogSlice";
import assignMemberSlice from "./slices/assignMemberSlice";
import roleSlice from "./slices/roleSlice";
import teamSlice from "./slices/teamsSlice";
import viewAllIssueSlice from "./slices/viewAllIssuesSlice";
import supportSlice from "./slices/supportSlice";
import dashboardSlice from "./slices/dashboardSlice";
import releaseSlice from "./slices/releaseSlice";
import releaseApproversReducer from "./slices/releaseApproveSlice";
import relatedWorkSlice from "./slices/relatedWorkSlice";
import errorLogSlice from "./slices/errorLogSlice";
import supportCustomerSlice from "./slices/supportCustomerSlice";
import timelineSlice from "./slices/timelineSlice";
import permissionSlice from "./slices/permissionSlice";

const rootReducer = {
  global: globalSlice,
  project: projectSlice,
  dashboard: dashboardSlice,
  issue: issueSlice,
  activeSprint: activeSprintSlice,
  profile: profileSlice,
  backlog: backlogSlice,
  assignMember: assignMemberSlice,
  role: roleSlice,
  team: teamSlice,
  viewAllIssue: viewAllIssueSlice,
  support: supportSlice,
  release: releaseSlice,
  releaseApprovers: releaseApproversReducer,
  relatedWork: relatedWorkSlice,
  errorLog: errorLogSlice,
  supportCustomer:supportCustomerSlice,
  timeline: timelineSlice,
  permission: permissionSlice
};

export default rootReducer;
